import React from "react";

import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import { setVehicle } from "../../redux/slices/addVehicleSlice";
import { Calendar } from "react-date-range";
import { enUS } from "date-fns/locale";
import { RiDeleteBin5Line } from "react-icons/ri";

import { base64StringToFile, fileToBase64 } from "../../utils/stringToBytes32";

// type VehicleData = {
//   vin: string;
//   insuranceProvider: string;
//   insuranceProviderNumber: number;
//   insuranceEffectiveDate: string;
//   insuranceExpDate: string;
//   policyNumber: number;
// };
// type VehicleDetailsProps = VehicleData & {
//   updateFields: (fields: Partial<VehicleData>) => void;
// };

const VehicleDetails: React.FC = () => {
  const addVehicle = useSelector((state: any) => state.addVehicle.Vehicle[0]);

  const [effectiveDate, setEffectiveDate] = React.useState<string>(
    `${
      addVehicle?.insuranceEffectiveDate
        ? new Date(addVehicle?.insuranceEffectiveDate)?.toLocaleDateString(
            "en-US"
          )
        : "Select Date"
    }`
  );
  const [showEffectiveDate, setShowEffectiveDate] =
    React.useState<boolean>(false);

  const [expiryDate, setExpiryDate] = React.useState<string>(
    `${
      addVehicle?.insuranceExpDate
        ? new Date(addVehicle?.insuranceExpDate)?.toLocaleDateString("en-US")
        : "Select Date"
    }`
  );
  const [showExpiryDate, setShowExpiryDate] = React.useState<boolean>(false);

  const handleEffectiveDateSelect = (date: any) => {
    // console.log(date);
    setShowEffectiveDate(false);
    dispatch(
      setVehicle({
        insuranceEffectiveDate: date.toISOString(),
      })
    );
    setEffectiveDate(date.toLocaleDateString("en-US"));
  };

  const handleExpiryDateSelect = (date: any) => {
    setShowExpiryDate(false);
    dispatch(
      setVehicle({
        insuranceExpDate: date.toISOString(),
      })
    );
    setExpiryDate(date.toLocaleDateString("en-US"));

    // console.log(date);
  };

  const dispatch = useDispatch();

  // console.log(addVehicle);

  const navigate = useNavigate();

  return (
    <>
      {/* <div className="w-full py-[100px] lg:py-[150px] bg-[#F6F7F9]"> */}
      <div className="flex w-[80%] lg:w-[70%] py-10 border rounded-2xl mx-auto justify-center  h-full  flex-col gap-4 lg:items-center  bg-white">
        <p className=" text-black text-center font-Poppins font-semibold lg:font-medium text-[25px] lg:text-[40px]  ">
          Let your car work for you
        </p>
        <div className="flex flex-col  gap-12 w-[90%] mx-auto  lg:w-2/3 ">
          <div className="flex w-full flex-col lg:flex-row justify-between gap-[40px]">
            <div className="flex w-full  flex-col">
              <label htmlFor="" className=" block ">
                Insurance Provider
              </label>
              <input
                type="text"
                className="w-full border border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3"
                placeholder="Insurance Provider"
                required
                value={addVehicle?.insuranceProvider}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  dispatch(
                    setVehicle({
                      insuranceProvider: e.target.value,
                    })
                  );
                }}
              />
            </div>
          </div>
          <div className="flex w-full flex-col lg:flex-row justify-between gap-[40px]">
            <div className="flex lg:w-1/2 flex-col">
              <label htmlFor="" className=" block ">
                Insurance Provider Number
              </label>
              <input
                type="text"
                className="w-full border border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3"
                placeholder="Insurance Provider Number"
                value={addVehicle?.insuranceProviderNumber}
                required
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  dispatch(
                    setVehicle({
                      insuranceProviderNumber: e.target.value,
                    })
                  );
                }}
              />
            </div>
            <div className="flex lg:w-1/2  flex-col">
              <label htmlFor="" className=" block ">
                Policy Provider Number
              </label>
              <input
                type="text"
                className="w-full border border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3"
                placeholder="Policy Provider Number"
                required
                value={addVehicle?.policyNumber}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  dispatch(
                    setVehicle({
                      policyNumber: e.target.value,
                    })
                  );
                }}
              />
            </div>
          </div>
          <div className="flex w-full flex-col lg:flex-row justify-between gap-[40px]">
            <div className="flex lg:w-1/2  flex-col">
              <label htmlFor="" className=" block ">
                Policy Effective Date
              </label>
              <div
                className="w-full border border-[#C4BFC6]
                lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3 py-3 cursor-pointer"
                onClick={() => {
                  setShowEffectiveDate(!showEffectiveDate);
                  setShowExpiryDate(false);
                }}
              >
                {effectiveDate}
              </div>
              <div className="w-full flex justify-center ">
                {showEffectiveDate && (
                  <Calendar
                    date={new Date()}
                    // minDate={new Date()}
                    onChange={handleEffectiveDateSelect}
                    locale={enUS}
                  />
                )}
              </div>
            </div>
            <div className="flex lg:w-1/2  flex-col">
              <label htmlFor="" className=" block ">
                Policy Expiry Date
              </label>
              <div
                className="w-full border border-[#C4BFC6]
                lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3 py-3 cursor-pointer"
                onClick={() => {
                  setShowExpiryDate(!showExpiryDate);
                  setShowEffectiveDate(false);
                }}
              >
                {expiryDate}
              </div>
              <div className="w-full flex justify-center ">
                {showExpiryDate && (
                  <Calendar
                    date={new Date()}
                    minDate={new Date()}
                    onChange={handleExpiryDateSelect}
                    locale={enUS}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="flex w-full flex-col lg:flex-row justify-between gap-[40px]">
            <div className="flex w-full flex-col">
              <label htmlFor="insuranceCardImage" className=" block ">
                Insurance card image (front)
              </label>
              {addVehicle?.insuranceCardImage ? (
                <div className="w-[150px] h-[150px] lg:w-[200px] lg:h-[200px] relative">
                  <RiDeleteBin5Line
                    onClick={() =>
                      dispatch(
                        setVehicle({
                          insuranceCardImage: "",
                        })
                      )
                    }
                    className="text-white text-[20px] contrast-200 cursor-pointer absolute right-0 m-2"
                  />
                  <img
                    src={addVehicle?.insuranceCardImage}
                    alt=""
                    className=" object-cover h-full w-full"
                  />
                </div>
              ) : (
                <input
                  type="file"
                  id="insuranceCardImage"
                  capture="environment"
                  accept="image/*"
                  className="w-full border border-[#C4BFC6] lg:outline-none lg:bg-[#E5F9EF] rounded-md p-3"
                  placeholder="Select Image"
                  required
                  // value={base64StringToFile(addVehicle?.insuranceCardImage).name}
                  onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
                    if (!e.target.files?.length) return;
                    const img = await fileToBase64(e.target.files[0]);

                    dispatch(
                      setVehicle({
                        insuranceCardImage: img,
                      })
                    );
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default VehicleDetails;
